/**
 * ログ出力用ミックスイン
 */

 export default {
     methods: {
         log: (...msg) => {
            if (process.env.NODE_ENV == 'development'){
                console.log(...msg);
            }
         }
     }
 }
